// Centralized push opt-in soft-ask event names (Sentry captureMessage strings).
//
// Mirrors the analytics.ts convention of keeping event-name strings in ONE place
// so the three call sites — PushOptInSheet (shown), MirrorPushSoftAsk and
// DailyCheckIn (outcomes) — can't drift apart and silently split a funnel.
export const PUSH_OPTIN_EVENT = {
  shown: "push_optin_shown",
  promptOpened: "push_optin_prompt_opened",
  granted: "push_optin_granted",
  denied: "push_optin_denied",
  decline: "push_optin_decline",
  dismissed: "push_optin_dismissed",
} as const;
